export interface DataPrivacyIgnoreInfoTypeForContentParams {
    comment?: string;
}

export enum DataPrivacyViolationStatus {
    fixed = 'fixed',
    ignored = 'ignored',
    active = 'active',
}
